import React from "react";
import "./Banner.css";

import samBanner from "../../Assets/newAsset/imaging/sam.webp";
function Banner({title}) {
  return (
    <div className="Banner_testimonial">
      <div className="bannerChild">
        <div className="lefSide_testimonial w-50">
          <h1>{title}</h1>
        </div>

        <div className="right_sideTestimonial w-50">
          <img src={samBanner} alt={samBanner} width="100%" />
        </div>
      </div>
    </div>
  );
}

export default Banner;
